import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import DialerPage from './DialerPage';
import useIdleLogout from '../../hooks/useIdleLogout';

// Página independiente del webphone: se abre en su propia pestaña y es la
// ÚNICA parte de la app que registra la extensión (ver SoftphoneProvider en
// App.js). El dashboard ya no registra en segundo plano, así que hay que
// mantener esta pestaña abierta para recibir llamadas.
export default function WebphonePage() {
  // useIdleLogout es cross-tab (comparte el timestamp de actividad por
  // localStorage): sin esto, la actividad aquí no cuenta y el dashboard
  // puede cerrar la sesión de esta pestaña por "inactividad" aunque el
  // agente esté en plena llamada.
  useIdleLogout();

  return (
    <div className="min-h-screen bg-gray-950">
      <header className="h-14 flex items-center px-6 border-b border-gray-800">
        <Link to="/" className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors">
          <div className="w-7 h-7 bg-blue-600 rounded-lg flex items-center justify-center">
            <Phone size={14} className="text-white" />
          </div>
          <span className="font-semibold text-sm">PBX Virtual</span>
        </Link>
      </header>
      <div className="p-6">
        <DialerPage />
      </div>
    </div>
  );
}
